export default "__VITE_ASSET__SnnMB5LJ__"